import { Emitter } from "@welshman/lib";
export class Multi extends Emitter {
    targets;
    constructor(targets) {
        super();
        this.targets = targets;
        targets.forEach(t => {
            t.on("*", (verb, ...args) => this.emit(verb, ...args));
        });
    }
    get connections() {
        return this.targets.flatMap(t => t.connections);
    }
    async send(...payload) {
        await Promise.all(this.targets.map(t => t.send(...payload)));
    }
    cleanup = () => {
        this.removeAllListeners();
        this.targets.forEach(t => t.cleanup());
    };
}
//# sourceMappingURL=Multi.js.map